import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./iconSelector.scss";
import {
  faBurgerSoda,
  faUtensils,
  faSalad,
  faPopcorn,
  faPlateUtensils,
  faFrenchFries,
  faForkKnife,
  faEgg,
  faCupStraw,
  faCupStrawSwoosh,
  faCarrot,
  faBacon,
  faFish,
  faBurrito,
  faWineBottle,
  faWineGlass,
  faWhiskeyGlass,
  faWhiskeyGlassIce,
  faTaco,
  faSoftServe,
  faSushiRoll,
  faSausage,
  faSandwich,
  faPretzel,
  faPizza,
  faPizzaSlice,
  faPancakes,
  faMug,
  faMartiniGlass,
  faIceCream,
  faHotdog,
  faHatChef,
  faCupTogo,
  faCoffeePot,
  faCheeseSwiss,
  faChampagneGlasses,
  faBowlHot,
  faBowlRice,
  faBagel,
  faBeerMug,
  faGolfFlagHole,
  faGolfClub,
  faGolfBallTee,
  faFolder,
  faFolderXmark,
  faFolderUser,
  faFolderPlus,
  faFolderMusic,
  faFolderMinus,
  faFolderMedical,
  faFolderMagnifyingGlass,
  faFolderImage,
  faFolderHeart,
  faFolderGrid,
  faFolderGear,
  faFolderBookmark,
  faFolderArrowUp,
  faFolderArrowDown,
  faStar,
  faPaperclip,
  faCartShopping,
  faCar,
  faGift,
  faUmbrella,
  faTag,
  faBarcode,
  faKey,
  faTicket,
  faSnowflake,
  faGamepad,
  faSun,
  faBagShopping,
  faBedFront,
  faGauge,
  faCarSide,
  faCableCar,
  faClock,
  faCashRegister,
  faFlagCheckered,
  faAward,
  faWrench,
  faTrophy,
  faHammer,
  faCoins,
  faFlag,
  faRingsWedding,
  faTablePicnic,
  faPersonSkiing,
  faShirt,
  faShirtRunning,
  faShirtLongSleeve,
  faHatCowboy,
  faIdCardClip,
  faTimes,
  faParking,
  faDoorOpen,
  faDoorClosed,
  faSmoking,
  faSmokingBan,
  faWater,
  faWalking,
  faSpa,
  faShower,
  faRestroom,
  faTv,
  faWifi,
  faPhone,
  faLaptop,
  faPersonSwimming,
  faDumbbell,
  faConciergeBell,
  faBroom,
  faAirConditioner,
  faCampfire,
  faPlug,
  faFaucet,
  faWashingMachine,
  faPaw,
  faTrashArrowUp,
  faTent,
  faPersonHiking,
  faWheelchair,
  faChargingStation,
  faRv,
} from "@fortawesome/pro-regular-svg-icons";
import Input from "components/form/input/Input";
import { useTranslation } from "react-i18next";

interface IEmojiGridProps {
  onIconSelect: (icon: string) => void;
  selectedIcon?: string; // Add prop for pre-selected icon
  initialFilter?: "all" | "amenities";
  excludeIcons?: string[]; // Icons to exclude from the grid (e.g., already used icons)
}

export const allIcons = {
  [faBurgerSoda.iconName]: faBurgerSoda,
  [faUtensils.iconName]: faUtensils,
  [faSalad.iconName]: faSalad,
  [faPopcorn.iconName]: faPopcorn,
  [faPlateUtensils.iconName]: faPlateUtensils,
  [faFrenchFries.iconName]: faFrenchFries,
  [faForkKnife.iconName]: faForkKnife,
  [faEgg.iconName]: faEgg,
  [faCupStraw.iconName]: faCupStraw,
  [faCupStrawSwoosh.iconName]: faCupStrawSwoosh,
  [faCarrot.iconName]: faCarrot,
  [faBacon.iconName]: faBacon,
  [faFish.iconName]: faFish,
  [faBurrito.iconName]: faBurrito,
  [faWineBottle.iconName]: faWineBottle,
  [faWineGlass.iconName]: faWineGlass,
  [faWhiskeyGlass.iconName]: faWhiskeyGlass,
  [faWhiskeyGlassIce.iconName]: faWhiskeyGlassIce,
  [faTaco.iconName]: faTaco,
  [faSoftServe.iconName]: faSoftServe,
  [faSushiRoll.iconName]: faSushiRoll,
  [faSausage.iconName]: faSausage,
  [faSandwich.iconName]: faSandwich,
  [faPretzel.iconName]: faPretzel,
  [faPizza.iconName]: faPizza,
  [faPizzaSlice.iconName]: faPizzaSlice,
  [faPancakes.iconName]: faPancakes,
  [faMug.iconName]: faMug,
  [faMartiniGlass.iconName]: faMartiniGlass,
  [faIceCream.iconName]: faIceCream,
  [faHotdog.iconName]: faHotdog,
  [faHatChef.iconName]: faHatChef,
  [faCupTogo.iconName]: faCupTogo,
  [faCoffeePot.iconName]: faCoffeePot,
  [faCheeseSwiss.iconName]: faCheeseSwiss,
  [faChampagneGlasses.iconName]: faChampagneGlasses,
  [faBowlHot.iconName]: faBowlHot,
  [faBowlRice.iconName]: faBowlRice,
  [faBagel.iconName]: faBagel,
  [faBeerMug.iconName]: faBeerMug,
  [faGolfFlagHole.iconName]: faGolfFlagHole,
  [faGolfClub.iconName]: faGolfClub,
  [faGolfBallTee.iconName]: faGolfBallTee,
  [faFolder.iconName]: faFolder,
  [faFolderXmark.iconName]: faFolderXmark,
  [faFolderUser.iconName]: faFolderUser,
  [faFolderPlus.iconName]: faFolderPlus,
  [faFolderMusic.iconName]: faFolderMusic,
  [faFolderMinus.iconName]: faFolderMinus,
  [faFolderMedical.iconName]: faFolderMedical,
  [faFolderMagnifyingGlass.iconName]: faFolderMagnifyingGlass,
  [faFolderImage.iconName]: faFolderImage,
  [faFolderHeart.iconName]: faFolderHeart,
  [faFolderGrid.iconName]: faFolderGrid,
  [faFolderGear.iconName]: faFolderGear,
  [faFolderBookmark.iconName]: faFolderBookmark,
  [faFolderArrowUp.iconName]: faFolderArrowUp,
  [faFolderArrowDown.iconName]: faFolderArrowDown,
  [faStar.iconName]: faStar,
  [faPaperclip.iconName]: faPaperclip,
  [faCartShopping.iconName]: faCartShopping,
  [faCar.iconName]: faCar,
  [faGift.iconName]: faGift,
  [faUmbrella.iconName]: faUmbrella,
  [faTag.iconName]: faTag,
  [faBarcode.iconName]: faBarcode,
  [faKey.iconName]: faKey,
  [faTicket.iconName]: faTicket,
  [faSnowflake.iconName]: faSnowflake,
  [faGamepad.iconName]: faGamepad,
  [faSun.iconName]: faSun,
  [faBagShopping.iconName]: faBagShopping,
  [faBedFront.iconName]: faBedFront,
  [faGauge.iconName]: faGauge,
  [faCarSide.iconName]: faCarSide,
  [faCableCar.iconName]: faCableCar,
  [faClock.iconName]: faClock,
  [faCashRegister.iconName]: faCashRegister,
  [faFlagCheckered.iconName]: faFlagCheckered,
  [faAward.iconName]: faAward,
  [faWrench.iconName]: faWrench,
  [faTrophy.iconName]: faTrophy,
  [faHammer.iconName]: faHammer,
  [faCoins.iconName]: faCoins,
  [faFlag.iconName]: faFlag,
  [faRingsWedding.iconName]: faRingsWedding,
  [faTablePicnic.iconName]: faTablePicnic,
  [faPersonSkiing.iconName]: faPersonSkiing,
  [faShirt.iconName]: faShirt,
  [faShirtRunning.iconName]: faShirtRunning,
  [faShirtLongSleeve.iconName]: faShirtLongSleeve,
  [faHatCowboy.iconName]: faHatCowboy,
  [faIdCardClip.iconName]: faIdCardClip,
  [faParking.iconName]: faParking,
  [faDoorOpen.iconName]: faDoorOpen,
  [faDoorClosed.iconName]: faDoorClosed,
  [faSmoking.iconName]: faSmoking,
  [faSmokingBan.iconName]: faSmokingBan,
  [faWater.iconName]: faWater,
  [faWalking.iconName]: faWalking,
  [faSpa.iconName]: faSpa,
  [faShower.iconName]: faShower,
  [faRestroom.iconName]: faRestroom,
  [faTv.iconName]: faTv,
  [faWifi.iconName]: faWifi,
  [faPhone.iconName]: faPhone,
  [faLaptop.iconName]: faLaptop,
  [faGolfFlagHole.iconName]: faGolfFlagHole,
  [faPersonSwimming.iconName]: faPersonSwimming,
  [faDumbbell.iconName]: faDumbbell,
  [faConciergeBell.iconName]: faConciergeBell,
  [faBroom.iconName]: faBroom,
  [faAirConditioner.iconName]: faAirConditioner,
  [faCampfire.iconName]: faCampfire,
  [faPlug.iconName]: faPlug,
  [faFaucet.iconName]: faFaucet,
  [faWashingMachine.iconName]: faWashingMachine,
  [faPaw.iconName]: faPaw,
  [faTrashArrowUp.iconName]: faTrashArrowUp,
  [faTent.iconName]: faTent,
  [faPersonHiking.iconName]: faPersonHiking,
  [faWheelchair.iconName]: faWheelchair,
  [faChargingStation.iconName]: faChargingStation,
  [faRv.iconName]: faRv,
};

export const amenityIcons = [
  // --- UNIVERSAL (Shared by all Property Types) ---
  faWifi.iconName, // Internet
  faParking.iconName, // Parking
  faPaw.iconName, // Pet Friendly
  faUtensils.iconName, // Dining/Restaurant
  faPersonSwimming.iconName, // Pool/Swimming
  faWheelchair.iconName, // Accessibility
  faPhone.iconName, // Communication
  faChargingStation.iconName, // EV Charging

  // --- CAMPING & OUTDOOR FOCUSED ---
  faCampfire.iconName, // Fire Pits
  faTent.iconName, // Tent Sites
  faRv.iconName, // RV Sites
  faPersonHiking.iconName, // Trails
  faGolfFlagHole.iconName, // Golf/Sport
  faPlug.iconName, // Electric Hookup
  faFaucet.iconName, // Water Hookup
  faShower.iconName, // Bathhouse
  faRestroom.iconName, // Public Toilets
  faWashingMachine.iconName, // Laundry
  faTrashArrowUp.iconName, // Dump Station/Trash

  // --- HOTEL & INDOOR FOCUSED ---
  faBedFront.iconName, // Guest Rooms
  faTv.iconName, // Entertainment
  faAirConditioner.iconName, // Climate Control
  faConciergeBell.iconName, // Front Desk
  faBroom.iconName, // Housekeeping
  faSpa.iconName, // Wellness
  faDumbbell.iconName, // Gym

  // --- POLICIES ---
  faSmoking.iconName,
  faSmokingBan.iconName,
];

// Manual keyword mapping for smarter search
const searchKeywords: Record<string, string[]> = {
  // Common terms for all
  connectivity: ["wifi", "internet"],
  internet: ["wifi", "internet"],
  dining: ["utensils", "burger-soda", "pizza", "coffee-pot", "martini-glass"],
  accessibility: ["wheelchair"],
  parking: ["parking", "car"],

  // Camping / Outdoor Specific
  camping: ["tent", "campfire", "person-hiking", "plug", "faucet", "trash-arrow-up"],
  hookups: ["plug", "faucet", "charging-station"],
  power: ["plug", "charging-station"],
  water: ["faucet", "shower", "person-swimming", "water-ladder"],
  outdoor: ["campfire", "tent", "person-hiking", "golf-flag-hole"],

  // Hotel / Indoor Specific
  hotel: ["bed-front", "concierge-bell", "broom", "tv", "air-conditioner", "luggage-cart"],
  room: ["bed-front", "tv", "air-conditioner", "phone"],
  wellness: ["dumbbell", "spa", "gym"],
  service: ["concierge-bell", "broom", "sparkles"],

  // Sport & Social
  golf: ["golf-flag-hole", "golf-ball-tee", "flag-pennant", "golf-club"],
  recreation: ["person-swimming", "person-hiking", "golf-flag-hole", "spa"],

  // Utility & Policy
  utility: ["washing-machine", "trash-arrow-up", "shower", "restroom", "laptop", "print"],
  policy: ["paw", "smoking", "smoking-ban", "pet"],
};

const EmojiGrid: React.FC<IEmojiGridProps> = ({
  onIconSelect,
  selectedIcon,
  initialFilter = "all",
  excludeIcons = [],
}) => {
  const { t } = useTranslation();
  const [recentlyUsed, setRecentlyUsed] = useState<string | null>(selectedIcon || null);

  useEffect(() => {
    setRecentlyUsed(selectedIcon || null);
  }, [selectedIcon]);

  const [searchIcons, setSearchIcons] = useState<string>("");

  // Function to handle icon selection and update the recently used icon
  const handleIconClick = (iconLabel: string) => {
    setRecentlyUsed(iconLabel);
    onIconSelect(iconLabel);
  };

  // Function to handle deselecting an icon
  const handleDeselectIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    setRecentlyUsed(null);
    onIconSelect("");
  };

  // Filter icons based on the search term
  const filteredIcons =
    searchIcons.length > 0
      ? Object.keys(allIcons).filter(iconName => {
          const lowerQuery = searchIcons.toLowerCase();
          const lowerName = iconName.toLowerCase();

          // 1. Direct name match
          if (lowerName.includes(lowerQuery)) {
            return true;
          }

          // 2. Keyword match
          for (const [keyword, targets] of Object.entries(searchKeywords)) {
            if (keyword.includes(lowerQuery) || lowerQuery.includes(keyword)) {
              if (targets.some(target => lowerName.includes(target))) {
                return true;
              }
            }
          }
          return false;
        })
      : initialFilter === "amenities"
      ? amenityIcons
      : Object.keys(allIcons);

  // Filter out excluded icons (but keep the currently selected icon visible)
  const availableIcons = filteredIcons.filter(
    iconName => !excludeIcons.includes(iconName) || iconName === selectedIcon,
  );

  return (
    <>
      <div className="search-container">
        <Input
          placeholder={t("Search icons...")}
          onSearchClear={() => setSearchIcons("")}
          value={searchIcons}
          onChange={e => setSearchIcons(e.target.value)}
        />
      </div>

      <div className={`emoji-grid-container ${initialFilter === "amenities" ? "compact" : ""}`}>
        {/* All Icons in a single grid */}
        <div className="emoji-grid">
          {availableIcons.map((item, index) => (
            <div
              key={index}
              className={`emoji-item ${recentlyUsed === item ? "selected" : ""}`}
              onClick={() => handleIconClick(item)}
            >
              <FontAwesomeIcon icon={allIcons[item]} size="1x" />
              {recentlyUsed === item && (
                <div className="deselect-x" onClick={handleDeselectIcon}>
                  <FontAwesomeIcon icon={faTimes} size="xs" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EmojiGrid;
